var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.600001 4.21849L4.24001 0.724484C4.70951 0.25909 5.34423 -0.00139989 6.00531 5.65862e-06C6.66639 0.00141121 7.29999 0.264598 7.76751 0.731984L11.4025 4.21849L7.06051 8.561C6.77467 8.83347 6.39492 8.98547 6.00001 8.98547C5.6051 8.98547 5.22535 8.83347 4.93951 8.561L0.600001 4.21849ZM7.77001 9.2685C7.30119 9.73718 6.66542 10.0005 6.00251 10.0005C5.3396 10.0005 4.70383 9.73718 4.23501 9.2685L0.0800001 5.11499C0.0298912 5.28561 0.00298277 5.46219 0 5.63999V10.6C0 11.3732 0.626801 12 1.4 12H10.6C11.3732 12 12 11.3732 12 10.6V5.63999C11.997 5.46219 11.9701 5.28561 11.92 5.11499L7.77001 9.2685Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/GmailIcon.423ef9835f5e114af73570a221794f07.svg";
export { ForwardRef as ReactComponent };